import { lazy, Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const GARegister = lazy(() => import('../pages/ga-register'))

export const gaRegisterRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/ga-register',
  component: GARegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
